const types = {
	internal: 'internal',
	external: 'external'
};

const locale = {
	ru: {
		internal: 'внутренний',
		external: 'внешний'
	},
	en: types,
	uk: types,
	de: {
		internal: 'intern',
		external: 'ex­tern'
	},
	vi: types,
	th: {
		internal: 'ภายใน',
		external: 'ภายนอก'
	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/campaign-domain-types.js